<main id="content" style="direction: rtl;" role="main" class="main">
  <div class="content container">
    <div>
      <nav aria-label="breadcrumb">
        <ol id="w1" class="breadcrumb">
          <li class="breadcrumb-item">الرئيسية</li>
          <li class="breadcrumb-item active" aria-current="page">مؤسسة تنمية أموال الأيتام</li>
        </ol>
      </nav>
    </div>
    <div class="company-index">
      <h1>الغاء الطلبات التابعة لشهر {{ previousMonth }}/{{ previousYear }} </h1>

      <!-- عرض الـ Spinner فقط عندما تكون البيانات قيد التحميل -->
      <div *ngIf="isLoading" class="spinner-container">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <!-- عرض رسالة لا يوجد بيانات إذا كانت القائمة فارغة -->
      <div *ngIf="!isLoading && requests && requests.length === 0" class="no-data-message">
        لا يوجد طلبات عالقة للشهر الماضي {{ previousMonth }}/{{ previousYear }}
      </div>

      <!-- عرض الجدول عندما تكون البيانات جاهزة -->
      <div *ngIf="!isLoading && requests && requests.length > 0" id="w0" class="grid-view">
        <!-- عرض عدد العناصر في الأعلى -->
        <div class="summary-info">
          <span class="showing-info">
            Showing <b>{{ (currentIndex - 1) * 10 + 1 }} - {{ currentIndex * 10 < requests.length ? currentIndex * 10 : requests.length }}</b> of <b>{{ requests.length }}</b> items.
          </span>
        </div>

        <!-- عرض الجدول -->
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th style="text-align: right;">رقم الطلب</th>
              <th style="text-align: right;">الرقم الوطني</th>
              <th style="text-align: right;">تاريخ التقديم</th>
              <th style="text-align: right;"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of paginatedRequests; let i = index">
              <td style="text-align: right;">{{ item.applicationNumber }}</td>
              <td style="text-align: right;">{{ item.nationalId }}</td>
              <td style="text-align: right;">{{ item.createdAt }}</td>
              <td style="text-align: start;display: flex;align-items: center;">

                
                <a  class="py-1 px-2 delete-btn" title="الغاء الطلب" (click)="deleteRequest(i)">
                  <i class="fa fa-times"></i>
                </a>

                <a class="py-1 px-2" target="_blank" title="عرض" href="/Form?serviceId={{item?.carbonId}}&showForm=true&serviceType=CURRENT">
                  <i class="fa fa-eye"></i>
                </a>
              
              </td>
            </tr>
          </tbody>
        </table>
        

        <!-- أزرار التنقل (في الأسفل ووسط الصفحة) -->
        <nav *ngIf="requests.length > 10" aria-label="Page navigation example">
          <ul class="pagination justify-content-center">
            <!-- زر Previous -->
            <li class="page-item" [ngClass]="{'disabled': currentIndex <= 1}">
              <a class="page-link" (click)="previousPage(); $event.preventDefault()" href="#" [attr.disabled]="currentIndex <= 1 ? true : null">Previous</a>
            </li>

            <!-- أرقام الصفحات الديناميكية -->
            <li class="page-item" *ngFor="let page of pageNumbers" [ngClass]="{'active': page === currentIndex}">
              <a class="page-link" (click)="goToPage(page); $event.preventDefault()" href="#">{{ page }}</a>
            </li>

            <!-- زر Next -->
            <li class="page-item" [ngClass]="{'disabled': currentIndex >= totalPages}">
              <a class="page-link" (click)="nextPage(); $event.preventDefault()" href="#" [attr.disabled]="currentIndex >= totalPages ? true : null">Next</a>
            </li>
          </ul>
        </nav>

      </div>
    </div>
  </div>
</main>


<p-toast></p-toast>